import React from "react";
import PropTypes from "prop-types";

const ProsConsComponent = ({ value }) => {
  const { prosItems, consItems, heading } = value || {};
  const title = heading || "Výhody a nevýhody";

  if (!prosItems?.length && !consItems?.length) {
    return null;
  }

  return (
    <div
      className='max-w-[680px] w-full mx-auto my-12'
      id='pros_cons_component'
    >
      <h2 className='text-2xl font-semibold mb-6 text-inaqgold'>{title}</h2>
      <div className='flex flex-row gap-12 sm:!flex-col sm:gap-8'>
        {/* Pros Column */}
        {prosItems?.length > 0 && (
          <div className='flex-1'>
            <h3 className="text-inaqgold text-xl font-bold mb-4 font-['Oxanium']">
              Výhody
            </h3>
            <ul className='space-y-3'>
              {prosItems.map((item, index) => (
                <li key={index} className='flex items-start gap-3'>
                  {/* Check Icon */}
                  <svg
                    width='20'
                    height='20'
                    viewBox='0 0 24 24'
                    className='flex-shrink-0 mt-0.5'
                    xmlns='http://www.w3.org/2000/svg'
                  >
                    <path
                      d='M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41L9 16.17z'
                      fill='#6a604d'
                    />
                  </svg>
                  <span className='text-gray-700 font-rubik text-sm leading-relaxed'>
                    {item.text}
                  </span>
                </li>
              ))}
            </ul>
          </div>
        )}

        {/* Cons Column */}
        {consItems?.length > 0 && (
          <div className='flex-1'>
            <h3 className="text-inaqgold text-xl font-bold mb-4 font-['Oxanium']">
              Nevýhody
            </h3>
            <ul className='space-y-3'>
              {consItems.map((item, index) => (
                <li key={index} className='flex items-start gap-3'>
                  {/* Minus Icon */}
                  <svg
                    width='20'
                    height='20'
                    viewBox='0 0 24 24'
                    className='flex-shrink-0 mt-0.5'
                    xmlns='http://www.w3.org/2000/svg'
                  >
                    <path d='M19 13H5v-2h14v2z' fill='#6a604d' />
                  </svg>
                  <span className='text-gray-700 font-rubik text-sm leading-relaxed'>
                    {item.text}
                  </span>
                </li>
              ))}
            </ul>
          </div>
        )}
      </div>
    </div>
  );
};

ProsConsComponent.propTypes = {
  value: PropTypes.shape({
    heading: PropTypes.string,
    prosItems: PropTypes.arrayOf(
      PropTypes.shape({
        text: PropTypes.string.isRequired,
      })
    ),
    consItems: PropTypes.arrayOf(
      PropTypes.shape({
        text: PropTypes.string.isRequired,
      })
    ),
  }),
};

export default ProsConsComponent;
